import classNames from "classnames";
import { useTranslations } from "next-intl";

import { Actions, ShowWhen } from "@/components/common";
import { Category } from "../get-parcels-table/components";
import { DollarIcon, MyParcelsIcon } from "@/components/assets/icons";

const ProductDetails = ({
  category,
  productSubCategory,
  productPrice,
  productQuantity,
  productId,
  onDelete,
  onEdit,
}: {
  category: {
    id: number;
    value: string;
  };
  productSubCategory?: string;
  productPrice: string;
  productQuantity?: string;
  productId: number;
  onDelete?: () => void;
  onEdit?: () => void;
}) => {
  const t = useTranslations();
  return (
    <div className="w-full rounded-[20px] bg-[#F9F9F9] p-[12px]">
      <div className="flex border-b-[1px] border-[#f1f1f1] pb-[12px]">
        <div
          className={classNames(
            "mr-[8px] flex items-center justify-center rounded-[50%] bg-[#F9F9F9]",
          )}
        >
          <Category category={category?.id} />
        </div>
        <div className="flex flex-col justify-center gap-[3px]">
          <h4 className="text-xs font-semibold text-black">
            {category?.value}
          </h4>
          <h5 className="text-xs font-medium text-black opacity-50">
            {productSubCategory}
          </h5>
        </div>
        <div
          className={classNames(
            "ml-auto flex h-[40px] min-h-[40px] w-[40px] min-w-[40px] cursor-pointer items-center justify-center rounded-[50%] bg-white",
          )}
        >
          <Actions onEdit={onEdit} onDelete={onDelete} showBorder={false} />
        </div>
      </div>
      <div className="flex gap-[2.375rem] pt-[12px]">
        <ShowWhen condition={!!productQuantity}>
          <div className="flex">
            <div
              className={classNames(
                "mr-[8px] flex h-[40px] min-h-[40px] w-[40px] min-w-[40px] items-center justify-center rounded-[50%] bg-white",
              )}
            >
              <MyParcelsIcon />
            </div>
            <div className="flex flex-col justify-center gap-[3px]">
              <h4 className="text-xs font-semibold text-black">
                {t("quantity")}
              </h4>
              <h5 className="text-xs font-medium text-black opacity-50">
                {productQuantity}
              </h5>
            </div>
          </div>
        </ShowWhen>
        <div className="flex">
          <div
            className={classNames(
              "mr-[8px] flex h-[40px] min-h-[40px] w-[40px] min-w-[40px] items-center justify-center rounded-[50%] bg-white",
            )}
          >
            <DollarIcon />
          </div>
          <div className="flex flex-col justify-center gap-[3px]">
            <h4 className="text-xs font-semibold text-black">
              {t("product_price")}
            </h4>
            <h5 className="text-xs font-medium text-black opacity-50">
              {productPrice}
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
